export const selectCurrentTheme = (state) => state.theme.mode;
